import * as React from "react";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import IconWrapper from "../../../../hiberUiKit/src/atoms/Icon/IconWrapper";

export interface PartnerBrandAction {
	label: string;
	onSelect: () => void;
	disabled?: boolean;
}

interface Props {
	/**
	 * Actions in use.
	 */
	actions: PartnerBrandAction[];
	/**
	 * Actions kept for the rare case, listed under a "Legacy" heading.
	 */
	legacyActions: PartnerBrandAction[];
	/**
	 * Indicates if the form holds changes not saved yet. Actions work on the saved brand, so the menu says so.
	 */
	hasUnsavedChanges: boolean;
}

interface State {
	open: boolean;
}

/**
 * "Actions" button opening a menu of the partner brand actions.
 */
export default class PartnerBrandActionsMenu extends React.PureComponent<Props, State> {
	container: HTMLDivElement;

	constructor(props: Props) {
		super(props);
		this.state = {open: false};
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.onOutsideClick);
	}

	render() {
		return (
			<div className={"c-pb-actions"} ref={el => this.container = el}>
				<button type={"button"}
						className={"a-button-primary burgundy c-pb-actions_toggle"}
						aria-haspopup={"menu"}
						aria-expanded={this.state.open}
						onClick={this.toggle}>
					<span>Actions</span>
					<IconWrapper icon={Icon.ArrowDown} size={14} variant={"white"}/>
				</button>
				{this.state.open &&
				<div className={"c-pb-actions_menu"} role={"menu"}>
					{this.props.hasUnsavedChanges &&
					<p className={"c-pb-actions_note"}>Unsaved changes. Actions use the saved brand.</p>}
					<div className={"c-pb-actions_group"}>
						{this.props.actions.map(this.renderItem)}
					</div>
					{this.props.legacyActions.length > 0 &&
					<div className={"c-pb-actions_group"}>
						<p className={"c-pb-actions_heading"}>Legacy</p>
						{this.props.legacyActions.map(this.renderItem)}
					</div>}
				</div>}
			</div>
		);
	}

	renderItem = (action: PartnerBrandAction) =>
		<button key={action.label}
				type={"button"}
				role={"menuitem"}
				className={"c-pb-actions_item"}
				disabled={action.disabled}
				onClick={() => this.select(action)}>
			{action.label}
		</button>;

	toggle = () => this.state.open ? this.close() : this.open();

	open() {
		document.addEventListener("mousedown", this.onOutsideClick);
		this.setState({open: true});
	}

	close() {
		document.removeEventListener("mousedown", this.onOutsideClick);
		this.setState({open: false});
	}

	select(action: PartnerBrandAction) {
		this.close();
		action.onSelect();
	}

	onOutsideClick = (evt: Event) => {
		if (this.container && !this.container.contains(evt.target as Node)) {
			this.close();
		}
	}
}
